<template>
  <div
    :class="[
      'filter-panel',
      mobileOpen ? 'mobile-open' : '',
      changeMobileFilterPosition ? 'rel' : '',
      'el-size--small'
    ]"
  >
    <i
      v-if="withToggle"
      @click="mobileOpen = !mobileOpen"
      :class="[
        'toggle',
        'fal',
        !mobileOpen ? 'fa-sliders-h' : 'fa-chevron-left'
      ]"
    ></i>
    <div v-if="uiFilters.length" class="filter-panel--search pb-m">
      <div :class="['search-field', searchActive ? 'focused' : '']">
        <input
          class="px-xs"
          @focus="searchFocus"
          @blur="searchBlur"
          type="text"
          :placeholder="localize('Search')"
          v-model="searchString"
          ref="search"
        />
        <i
          @click="clearSearchString"
          :class="['mr-xs', 'fal', searchString ? 'fa-times' : 'fa-search']"
        ></i>
      </div>
    </div>
    <div :class="['filter-panel--inner', searchActive ? 'search-active' : '']">
      <span v-if="category && category.title" class="search-label">
        {{ localize("Searching in") }}
        <strong v-text="localize(category.title)"></strong
      ></span>
      <div class="active-filters" v-if="!!activeFilters.length">
        <h4
          class="pb-s text--s"
          v-text="localize('Currently filtered by') + ':'"
        ></h4>
        <transition-group
          name="filter-list"
          tag="ul"
          :style="'height:' + calcActiveHeight + 'px'"
        >
          <li
            v-for="item in activeFilters"
            :key="item.name"
            class="filter-list-item"
          >
            <span v-text="localize(item.label || item.name)"></span>
            <a href="#p" @click.prevent="removeFilter(item)" class="btn remove"
              ><i></i
            ></a>
          </li>
        </transition-group>
      </div>
      <div
        v-for="filter in uiFilters"
        :ref="'filterblock_' + filter.type"
        :class="[
          'filter-block',
          'mb-l',
          filter.visible ? 'open' : 'closed',
          isNumericFilter(filter) ? 'numeric-filter' : '',
          isBooleanFilter(filter) ? 'single-filter' : ''
        ]"
        :key="filter.type"
      >
        <h4
          @click="filter.visible = !filter.visible"
          class="text-blue-p text--s pointer"
        >
          <i
            class="toggler fal fa-chevron-down text-blue-p text--s"
            :class="[filter.visible ? 'open' : '']"
          ></i>
          <!-- <a href="#p" :class="['btn', 'minmax', filter.visible ? 'min' : '']"
            ><i></i
          ></a> -->
          <span
            class="font-rg"
            v-text="localize(filter.label || filter.name)"
          ></span>
          
          <!--<span>{{filter.max}}</span>-->
        </h4>
        <vue-slider
          v-if="filter.max && filter.max > 0"
          ref="slider"
          :dotSize="10"
          :max="Math.ceil(filter.max)"
          :enable-cross="false"
          :interval="0.5"
          :bgStyle="{ height: '1px', backgroundColor: '#b7b8b9' }"
          :sliderStyle="[
            { backgroundColor: '#fff', top: '-4px' },
            { backgroundColor: '#fff', top: '-4px' }
          ]"
          tooltip="focus"
          :dotOptions="{
            tooltipStyle: [
              {
                borderRadius: '5px',
                border: '0',
                backgroundColor: '#fff',
                color: '#3498db',
                minWidth: '10px',
                fontSize: '13px'
              },
              {
                borderRadius: '5px',
                border: '0',
                backgroundColor: '#fff',
                color: '#3498db',
                minWidth: '10px',
                fontSize: '13px'
              }
            ]
          }"
          width="80%"
          v-model="filter.value"
        >
        </vue-slider>
        <ul v-else class="filter-items no-style">
          <li v-for="item in orderedFilters(filter.filters)" :key="item.id">
            <label>
              <span :class="['check', !!item.active ? 'checked' : '']"
                ><input v-model="item.active" type="checkbox" hidden
              /></span>
              <span
                class="filter-label lbl text--xs text-gray-8 ml-s"
                v-text="localize(item.label || item.name)"
              ></span>
            </label>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-unused-vars */
import { stringToQuery } from "@/utils";
import vueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import { mapActions, mapState, mapGetters } from "vuex";
export default {
  props: {
    mobileOpen: {
      type: Boolean,
      default: false
    },
    withToggle: {
      type: Boolean,
      default: false
    },
    triggerQuery: {
      default: -1
    },
    uiFilters: {
      type: Array,
      required: true
    },
    inputSearch: {
      type: String,
      default: null
    },
    category: Object,
    size: String
  },
  data() {
    return {
      searchActive: false,
      searchString: "",
      queryfiltered: false,
      // mobileOpen: false,
      curcategory: null,
      fromfilters: false,
      changeMobileFilterPosition: false,
      timer: -1
    };
  },
  detroyed() {
    // window.removeEventListener('hashchange', this.init, false);
  },
  mounted() {
    this.$nextTick(function() {
      if (this.activeFilters.length) this.sendActiveFiltersToCatalog();
      if (this.inputSearch) {
        this.searchString = this.inputSearch;
      }
    });
  },
  components: {
    vueSlider
  },
  watch: {
    inputSearch: function() {
      // console.log("input search changed >> ", this.inputSearch);
      if (this.inputSearch) {
        this.searchString = this.inputSearch;
      }
    },
    mobileOpen() {
      clearTimeout(this.timer);
      // console.log("mobileOpen");
      this.$emit("mobile-filters-open", this.mobileOpen);
      // this.timer = setTimeout(
      //   function() {
      //     this.changeMobileFilterPosition = this.mobileOpen;
      //   }.bind(this),
      //   400
      // );
    },
    activeFilters() {
      // console.log("WHY AGAIN ACTIVEFILTER   >> ", this.activeFilters);
      this.sendActiveFiltersToCatalog();
    },
    triggerQuery() {
      // console.log('TRIGGE QUERY, ', this.fromfilters);
      if (!this.fromfilters) {
        // this.init();
      }
      this.fromfilters = false;
    },
    searchString: _.debounce(function() {
      if (this.searchString && this.searchString.length >= 2) {
        this.searchByString();
      }
    }, 400)
  },
  methods: {
    ...mapActions(["updateFiltersHash"]),
    searchFocus() {
      console.log();
      this.searchActive = true;
    },
    searchBlur() {
      if (!this.searchString) {
        this.searchActive = false;
        this.$emit("search-by-string", null);
      }
    },
    clearSearchString() {
      if (this.searchString) {
        this.searchString = null;
        this.searchBlur();
      } else {
        this.$refs.search.focus();
      }
    },
    searchByString() {
      this.$emit("search-by-string", this.searchString);
    },
    orderedFilters(list) {
      return _.orderBy(list, "name");
    },
    sendActiveFiltersToCatalog: _.debounce(function() {
      this.fromfilters = true;
      // console.log("1 active filters changed> ", this.activeFilters);
      this.$nextTick(function() {
        this.updatefilterQuery(this.uiFilters);
        this.$emit("filters-changed", this.activeFilters);
        setTimeout(
          function() {
            this.fromfilters = false;
          }.bind(this),
          300
        );
      });
    }, 300),
    /*
			Sync URL query to filteration activity
			FILTERS > TO > QUERY
		*/
    updatefilterQuery() {
      let filters = this.activeFilters,
        qstring = "?",
        count = 0;
      if (!!filters && !!filters.length) {
        let groupedByKey = _.groupBy(filters, "key");
        // console.log("groupedByKey >> ", groupedByKey);
        _.each(groupedByKey, (v, k) => {
          let values;
          if (k !== "undefined") {
            values = _.map(v, "name");
            qstring += `${count < 1 ? "" : "&"}${k}=${values.join(",")}`;
            count++;
          } else {
            for (var i = 0; i < v.length; i++) {
              if (v[i].value[i] !== v[i].min || v[i].value[1] !== v[i].max) {
                k = v[i].name;
                values = _.clone(v[i].value);
                qstring += `${count < 1 ? "" : "&"}${k}=${values.join(",")}`;
                count++;
              }
            }
          }
        });
      }
      let query = stringToQuery(qstring);
      this.$router.query = query;
      this.$router.push({ name: this.$route.name, query }).catch(err => {
        // console.log("router err >", err);
      });
    },
    removeFilter(filter) {
      let find = _.find(this.uiFilters, { type: filter.type });
      if (!filter.value) {
        find = _.find(find.filters, { id: filter.id });
      } else {
        filter.value = [filter.min, filter.max];
        filter.visible = false;
      }
      find.active = false;
      this.updatefilterQuery();
    },
    isBooleanFilter(filter) {
      return filter.datatype === "1";
    },
    isNumericFilter(filter) {
      return filter.datatype === "0";
    }
  },
  computed: {
    activeFilters() {
      let filters = this.uiFilters;
      // console.log("ACITVEFILTER > > > > > ", filters);
      return _.reduce(
        filters,
        function(result, value, key) {
          let _activefilters = [];
          if (value.value) {
            let val = value.value;
            if (val[0] !== value.min || val[1] !== value.max) {
              _activefilters.push(value);
            }
          } else if (!value.filters.length) {
            if (value.active) {
              _activefilters.push(value);
            }
          } else {
            _activefilters = _.filter(value.filters, "active");
            _.each(_activefilters, function(filter) {
              filter.type = value.type;
              filter.key = value.name;
            });
          }
          result.push(..._activefilters);
          return result;
        },
        []
      );
    },
    calcActiveHeight() {
      return this.activeFilters.length * 60;
    }
  }
};
</script>

<style lang="stylus">

gray = #b7b8b9

.filter-label
  max-width 80%
  display inline-block
  vertical-align top
.remove, .minmax
	cursor pointer
	position absolute
	right 15px
	top 50%
	transform translate(0, -50%)
	width 15px
	height @width
	&:before
		content ''
		position absolute
		top 0
		left 0
		width 19px
		height @width
	&:after
		content ''
		position absolute
		width 23px
		height @width
		top -2px
		left -2px
	i
		center()
		width 70%
		height @width
		&:after, &:before
			content ''
			position absolute
			top 50%
			left 50%
			width 1px
			height 100%
			transform translate(-50%, -50%) rotate(-45deg)
			background blue_5
			transition background 0.3s ease-out
		&:after
			transform translate(-50%, -50%) rotate(45deg)
	&:hover
		&:before, &:after
			border-color rgba(#fff, 0.2)
		i
			&:before, &:after
				background lighten(#7f949f, 15)
.minmax
	position relative
	transform none
	left auto
	right auto
	top auto
	i:after
		transform translate(-50%, -50%)
		transition transform 0.2s
	i:before
		transform translate(-50%, -50%) rotate(-90deg)
		transition transform 0.2s ease-out
	&.min
		i:after
		i:before
			transform translate(-50%, -50%) rotate(-90deg)
.filter-panel
  width 240px
  position relative
  z-index 9
  transition transform 0.3s ease-out, opacity 0.3s ease-out
  will-change transform, opacity
  opacity 1
  &.waiting
    opacity 0
  +above(815px)
    padding-right 30px
    position sticky
    top 250px
  &--search
    .search-field
      border-bottom 1px solid rgba(gray_4, 0.5)
      position relative
      height 40px
      &.focused
        box-shadow 0 0 20px rgba(45,45,45,0.2)
      i
        position absolute
        top 50%
        right 0
        transform translate(-50%, -50%) rotate(0)
        transform-origin center
        opacity 0.8
        transition opacity 0.5s ease-out, transform 0.5s ease-out
        will-change opacity, transform
        backface-visibility hidden
        cursor pointer
        &:hover
          opacity 1
        &.fa-times
          transform translate(-50%, -50%) rotate(-90deg)
        &.fa-search
          // transition opacity 0.5s ease-out, transform 1s ease-out
          transform translate(-50%, -50%) rotate(0deg)

      input
        border 0
        width 100%
        height 100%
        outline 0
        +below(815px)
          font-size 16px

  &--inner
    position relative
    .search-label
      position absolute
      left 0
      top 0
      z-index 98
      text-align left
      width 100%
      color gray_6
      opacity 0
      transition opacity 0.3s ease-out
    &:after
      content ''
      position absolute
      top 0
      left 0
      width 100%
      background linear-gradient(to bottom, rgba(#fff, 0.9), rgba(#fff, 0.8))
      height 0
      opacity 0
      overflow hidden
      transition opacity 0.6s ease-out, height 0.6s ease-out
    &.search-active
      &:after
        height 100%
        opacity 1
      .search-label
        opacity 1
        transition opacity 0.5s 0.3s ease-out
  & > i.toggle
    display none
  /.el-size--small &
    & > i.toggle
      display block
    position absolute
    background #fff
    height 100%
    // min-height 100vh
    width 100%
    left 0
    z-index 11
    margin-top 0
    transform translateX(-100%)
    will-change transform
    // transition transform 0.2s ease-out-quad, opacity 0.2s ease-out-quad
    top 0
    /.research--inner &
      top 10px
    .filter-panel--inner
      // max-height 54vh
      padding 10px 0
      // overflow auto
      position relative
    & > i
      color gray_8
      position fixed
      top 1.5vh
      left 100%
      transform translate(5.5vw, 5px)
      font-size 3vmax
      cursor pointer
      transition transform 0.4s ease-out-quad, right 0.4s ease-out-quad, left 0.4s ease-out-quad
      +portrait()
        transform translate(8.5vw, 5px)
    padding-top 15vh
    &.mobile-open
      position relative
      padding-top 2.5vh
      transform translateX(0)
      &.rel
        height auto
      & > i
        left auto
        right 0
        transform translate(-3.5vw, -5px)
        +portrait()
          transform translate(-5.5vw, -5px)

    h2
      color #fff
  .active-filters
    margin-bottom 30px
    h3
      float none
      padding 0 0 5px
      font-size 13px
      color gray_6
      line-height 1
      font-weight 200
    ul
      position relative
      transition height 0.2s linear
      li:nth-last-child(1):first-child
        border-bottom 1px solid rgba(#fff, 0.2)
        &:after
          content ''
          position absolute
          left 0
          bottom 0
          height 1px
          width 100%
          background gray_6
      li
        position relative
        width 100%
        padding 12px 15px
        border-top 1px solid gray_4
        transition all 0.5s ease-out
        &:before
          content ''
          position absolute
          left 0
          top 0
          height 1px
          width 100%
          background rgba(#fff, 0.2)
        span
          color gray_8
          font-size 12px
          text-transform uppercase
          max-width 80%
          display inline-block
        .remove
          cursor pointer
          position absolute
          right 15px
          top 50%
          transform translate(0, -50%)
          width 23px
          height @width
          border 1px solid gray_4
          &:before
            content ''
            position absolute
            top 0
            left 0
            width 19px
            height @width
            border 1px solid rgba(#fff, 0.1)
            transition border 0.3s ease-out
          &:after
            content ''
            position absolute
            width 23px
            height @width
            top -2px
            left -2px
            border 1px solid rgba(#fff, 0.1)
            transition border 0.3s ease-out
          i
            center()
            width 70%
            height @width
            &:after, &:before
              content ''
              position absolute
              top 50%
              left 50%
              width 1px
              height 100%
              transform translate(-50%, -50%) rotate(-45deg)
              background #7f949f
              transition background 0.3s ease-out
            &:after
              transform translate(-50%, -50%) rotate(45deg)
          &:hover
            &:before, &:after
              border-color rgba(#fff, 0.2)
            i
              &:before, &:after
                background lighten(#7f949f, 15)
	.filter-block
		position relative
		transition max-height 0.3s ease-out, padding 0.3s ease-out
		&.numeric-filter
			max-height 100px
		// &:first-child
		// 	padding-top 44px
		&.closed
			max-height 24px
			padding-bottom 0
			overflow hidden
		h4
      position relative
      text-transform uppercase
      margin 0 0 20px
      a
      span
      i
        display inline-block
        vertical-align middle
        font-size 13px //dubi
      i
        margin-right 10px
      .toggler
        cursor pointer
        flex 0 0 3%
        width 2vmin
        position relative
        display inline-block
        vertical-align middle
        transform-origin center center
        transition transform 0.4s ease-out-cubic
        &.open
          transform rotate3d(1, 0, 0, 180deg)
		// &.single-filter:not(.closed)
		// 	padding-bottom 44px
.filter-items
  padding-left 26px
  li
    margin-bottom 8px
    label
      white-space nowrap
      span:last-child
        white-space normal
  .check
    inline-mid()
    position relative
    border 1px solid gray_4
    width 22px
    height @width
    &:before
      content ''
      position absolute
      opacity 0
      top 50%
      left 50%
      width 6px
      height 3px
      border-left 1px solid #7f949f
      border-bottom 1px solid #7f949f
      transform scale(0) translate(-50%,-80%) rotate(360deg)
      transition opacity 0.2s ease-out, transform 0.25s ease-out
    &.checked
      check()
  .lbl
    inline-mid()
.filter-list-item
  display block
  position relative
  transform translate3d(0,0,0)

.filter-list-leave-active, .filter-list-enter-active
	position absolute !important
.filter-list-enter-to, .filter-list-leave
	opacity 1
	transform translateY(0px)
.filter-list-enter
	opacity 0
	transform translateY(30px)
.filter-list-leave-to
  opacity 0
  transform translateY(-30px)
.filter-list-move
	transition transform 1s
	display block

.vue-slider-component .vue-slider-tooltip-wrap.vue-slider-tooltip-top .vue-slider-tooltip:before
  color #ffffff

.vue-slider
  &-dot
    +below(815px)
      width 20px !important
      height 20px !important
</style>
